const isValidDate = (date: string) => {
  return new Date(date) instanceof Date && !Number.isNaN(new Date(date).getTime());
};

export default isValidDate;
